import request from '@/utils/httpRequest'

export function save(data) {
    return request({
        url: '/app/business/qualityprogressphotoinfo/save',
        method: 'post',
        data
    })
}

export function photoList(data) {
    return request({
        url: '/app/business/qualityprogressphotoinfo/list',
        method: 'get',
        params: data
    })
}

export function deletePhoto(pid) {
    return request({
        url: '/app/business/qualityprogressphotoinfo/delete/' + pid,
        method: 'post'
    })
}

export function getSubjectDropDown(workNo) {
    return request({
        url: '/app/common/getSubjectDropDown/' + workNo,
        method: 'get'
    })
}